<template>
    <div class="curtain-grey">
        <div class="body-option-color">
            <div class="border-option-color">
                <div class="text-title">选择视图颜色</div>
                <ul class="items-color">
                    <li class="item-color my-cursor"
                        :class="{'item-selected': item === color}"
                        :style="{backgroundColor: item}"
                        @click.stop="selected(item)"
                        v-for="(item) in colorItems">
                    </li>
                </ul>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import initData from "@/utils/initData";
export default {
    name: "OptionPriority",
    data(){
        return {
            color: "",
            colorItems: [],
        }
    },
    props: {
        hexColor: {
            type: String,
            default: "",
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", this.color);
            this.close();
        },
        selected: function(color){
            this.color = color;
        },
    },

    mounted(){
        this.color = this.hexColor;
        this.colorItems = initData.viewColor;
    },
}
</script>

<style scoped>
div.body-option-color{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}

div.border-option-color{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}

ul.items-color{
    width: 100%;
    height: auto;
    margin-top: 0.1rem;
    margin-bottom: 0.1rem;
    display: flex;
    flex-wrap: wrap;
    column-gap: 0.2rem;
    row-gap: 0.25rem;
    justify-content: center;
}

li.item-color{
    width: 0.4rem;
    height: 0.4rem;

    border-radius: 50%;
    border: 0.02rem solid transparent;
}
li.item-selected{
    border-color: #000000;
}
div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    padding: 0 0.34rem;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>